import React, { FC } from 'react';
import { makeStyles } from 'tss-react/mui';

import Paper from '@mui/material/Paper';
import Dialog from '@mui/material/Dialog';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import DialogContent from '@mui/material/DialogContent';
import CircularProgress from '@mui/material/CircularProgress';

import ArrowDownwardIcon from '@mui/icons-material/ArrowDownwardRounded';

import { transactionsTypes } from 'companion-app-components/flux/transactions';

import AmountField from 'components/QuickenControls/AmountField';

import { styles } from './styles';

const useStyles = makeStyles()(styles as Record<string, any>);

interface RecurrenceAssigningDialogProps {
  showAssignRecurrenceProgress: boolean;
  txForm: transactionsTypes.CashFlowTransaction;
  recurrencePayee: string;
  recurrenceFrequency: string;
}

const RecurrenceAssigningDialog: FC<RecurrenceAssigningDialogProps> = ({
  showAssignRecurrenceProgress,
  txForm,
  recurrencePayee,
  recurrenceFrequency,
}) => {
  
  const { classes } = useStyles();

  return (
    <Dialog 
      open={showAssignRecurrenceProgress}
    >
      <DialogContent
        className={classes.dialogContent}
      >
        <Typography variant="h5">
          Assigning
        </Typography>
        <Paper className={classes.paper}>
          <Typography variant="subtitle1">
            {txForm.payee}
          </Typography>
          {/* @ts-expect-error: missing props */}
          <AmountField value={txForm.amount} />
        </Paper>
        <ArrowDownwardIcon />
        <Paper className={classes.paper}>
          <Avatar sx={{ m: 2.5 }}>
            {recurrencePayee && recurrencePayee.length ? recurrencePayee[0].toUpperCase() : '*'}
          </Avatar>
          <Typography variant="h6">
            {recurrencePayee}
          </Typography>
          <Typography variant="caption">
            {recurrenceFrequency}
          </Typography>
        </Paper>
        <CircularProgress />
      </DialogContent>
    </Dialog>
  );
};

export default RecurrenceAssigningDialog;
